export default "<import-entities params=\"delegate: $data\"></import-entities>\n";